import request from "@/utils/request";



export function loginHeader() {
  return request({
    url: '/job/cache/login/header',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/cache.js